import { Text } from '@lounge-fe/ui-kit'
import { Money } from '@/components/Money'
import { useShopify } from '@/hooks/useShopify'
import { CurrencyCode } from '@shopify/hydrogen-react/storefront-api-types'
import { TextVariant } from '@lounge-fe/ui-kit/src/components/Text/types'

export const ProductPagePriceRange = ({
  minPrice,
  maxPrice,
  variant = 'title-five',
}: PriceProps) => {
  const { currency } = useShopify()

  return (
    <div className="flex gap-2">
      <Money
        variant={variant}
        className="text-[#888888]"
        as={Text}
        data={{
          amount: minPrice.toString(),
          currencyCode: (currency.active as CurrencyCode) ?? 'GBP',
        }}
      />
      <Text variant={variant} className="text-[#888888]">
        {'-'}
      </Text>
      <Money
        variant={variant}
        className="text-[#888888]"
        as={Text}
        data={{
          amount: maxPrice.toString(),
          currencyCode: (currency.active as CurrencyCode) ?? 'GBP',
        }}
      />
    </div>
  )
}

interface PriceProps {
  minPrice: number
  maxPrice: number
  variant?: TextVariant
}
